import React from 'react';
import { Label } from 'cw-ui-core';
import DotCommon from './DotCommon/DotCommon';

const DotLabel = props => (
    <DotCommon {...props}>
        <Label value={props.value} />
    </DotCommon>
);

export default DotLabel;
